/*
 DISORIENTED_SERIALS_LISTING
 Sreenath 3Nov2021 - Disoriented Serials Listing.
 Fetched the serials exclusively, removed getBrand API, made use of getSerials to populate brand name
*/

import { LinearProgress } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { IQuery } from '@models/query';
import { IStateApps } from '@models/state-app';
import { IStateServers } from '@models/state-servers';
import { IStoreState } from '@models/store-state';
import appLanguages from '@utils/app-languages';
import { getFormattedDateString, nowrapHeader, withConfirm } from '@utils/common';
import {
  appMuiTheme,
  enableSortOnlyOpts,
  muiDataTableCommonOptions,
} from '@utils/mui-datatables-ops';
import MUIDataTable, { MUIDataTableColumn } from 'mui-datatables';
import React from 'react';
import { connect } from 'react-redux';

import { compose } from 'redux';

import WhiteLinearProgress from '../../../elements/WhiteLinearProgress';
import { setSerialsQuery } from '../../../redux/actions/serversActions';
import { LIMIT_PAGINATION_MAX } from '@utils/default-query';
import { functions } from '@utils/firebase';

class SakeHistoryForRestaurantClass extends React.PureComponent<Props, State> {
  public static defaultProps: Partial<Props> = {
    viewType: 'stock',
  };

  public query = {};
  public pages = {
    offset: 0,
    limit: LIMIT_PAGINATION_MAX,
  };

  constructor(props) {
    super(props);

    const { apps, viewType, servers, setSerialsQuery } = this.props;
    const lang = apps.currentLanguage;
    const { user } = servers;
    const { location } = user;

    const query = {
      ...servers.serialsQuery,
      order: [
        ['restRecvAt', 'DESC'],
        ['code', 'ASC'],
      ],
      where: {
        $or: [{ brewShipRestLocId: location.id }, { distShipRestLocId: location.id }],
        restRecvAt: { $ne: null },
        restSoldAt: null,
      },
    };

    this.query = query;

    setSerialsQuery(this.query);

    const columns = [];
    columns.push({
      name: 'code',
      label: nowrapHeader(appLanguages.serialCode[lang]),
      options: { ...enableSortOnlyOpts },
    });
    columns.push({
      name: 'code',
      label: nowrapHeader(appLanguages.brand[lang]),
      options: {
        ...enableSortOnlyOpts,
        customBodyRender: (v) => this.getBrandName(v, lang),
      },
    });
    columns.push({
      name: 'restRecvAt',
      label: nowrapHeader(appLanguages.serialDistRegistrationAt[lang]),
      options: {
        ...enableSortOnlyOpts,
        customBodyRender: (v) => this.getReceiveDateText(v, lang),
      },
    });
    columns.push({
      name: 'restSoldAt',
      label: nowrapHeader(appLanguages.serialSoldRegistrationAt[lang]),
      options: {
        ...enableSortOnlyOpts,
        customBodyRender: (v) => this.getSoldDateText(v, lang),
        display: viewType === 'sold',
      },
    });

    this.state = {
      initialized: false,
      columns,
      serialsList: null,
      serialsTotalCounts: 0,
    };
  }

  componentDidMount() {
    this.fetchSerials(this.query);
  }

  fetchSerials(query) {
    const self = this;
    const request = functions.httpsCallable('getSerials');
    request(query)
      .then((result) => {
        const { data } = result;
        //Remove status 6 data
        data.objects = data.objects.filter(function (item) {
          console.log(item);
          return item.status !== 6;
        });
        self.setState({
          initialized: true,
          serialsList: data.objects,
          serialsTotalCounts: data.totalCounts,
        });
      })
      .catch((e) => console.error('error', e));
  }

  getReceiveDateText(dateString, lang) {
    let text = appLanguages.unreceived[lang];
    if (dateString) {
      const date = new Date(Date.parse(dateString));
      text = getFormattedDateString(date);
    }
    return text;
  }

  getSoldDateText(dateString, lang) {
    let text = '-'; // appLanguages.notonsale[lang];
    if (dateString) {
      const date = new Date(Date.parse(dateString));
      text = getFormattedDateString(date);
    }
    return text;
  }

  getBrandName(code: string, lang: string): string | null {
    const { serialsList } = this.state;
    if (serialsList) {
      const serial = serialsList.find((v) => v.code === code);
      return serial.brand?.name;
    }
  }

  requestQuery(options?: any) {
    const { servers } = this.props;
    const { user } = servers;
    const { location } = user;
    // Sreenath27thOct - Unordered serials list
    // query to fetch serials in ascending order and which are received by the restaurant recently.
    const query = {
      ...servers.serialsQuery,
      order: [
        ['restRecvAt', 'DESC'],
        ['code', 'ASC'],
      ],
      where: {
        $or: [{ brewShipRestLocId: location.id }, { distShipRestLocId: location.id }],
        restRecvAt: { $ne: null },
        restSoldAt: null,
      },
    };
    return { ...query, ...options };
  }

  updateQuery(newQuery) {
    const { setSerialsQuery } = this.props;
    const query = this.requestQuery(newQuery);
    setSerialsQuery(query);
    this.setState({ initialized: false }, () => {
      this.fetchSerials(query);
    });
  }

  handleOnChangePage(currentPage) {
    const { limit } = this.pages;
    this.pages.offset = currentPage * limit;
    this.updateQuery({ offset: this.pages.offset, limit: this.pages.limit });
  }

  handleOnChangeRowsPerPage(numberOfRows) {
    this.pages.limit = numberOfRows;
    this.updateQuery({ offset: 0, limit: numberOfRows });
  }

  handleOnColumnSortChange(changedColumn, direction) {
    const { columns } = this.state;
    for (let i = 0; i < columns.length; i += 1) {
      const column = columns[i];
      if (column.name === changedColumn) {
        if (direction.match(/desc/)) column.options.sortDirection = 'desc';
        else column.options.sortDirection = 'asc';
      } else {
        delete column.options.sortDirection;
      }
    }
    this.updateQuery({
      order: [[changedColumn, direction.match(/desc/) ? 'DESC' : 'ASC']],
      offset: this.pages.offset,
      limit: this.pages.limit,
    });
  }

  render() {
    const { servers } = this.props;
    const { initialized, columns, serialsList, serialsTotalCounts } = this.state;
    const currentPage = this.pages.offset / this.pages.limit;
    const numberOfRows = this.pages.limit;

    const isRequesting = servers.isRequesting || servers.isGetRequesting || !initialized;

    return (
      <>
        {isRequesting ? <LinearProgress /> : <WhiteLinearProgress />}
        <MuiThemeProvider theme={appMuiTheme}>
          <MUIDataTable
            title=''
            data={serialsList || []}
            columns={columns}
            options={{
              ...muiDataTableCommonOptions(),
              download: false,
              expandableRows: false,
              expandableRowsOnClick: false,
              onRowClick: (rowData, rowMeta) => console.log('onRowsSelect.', rowData, rowMeta),
              search: false,
              page: currentPage,
              rowsPerPage: numberOfRows,
              count: serialsTotalCounts,
              onChangePage: (currentPage) => this.handleOnChangePage(currentPage),
              onChangeRowsPerPage: (numberOfRows) => this.handleOnChangeRowsPerPage(numberOfRows),
              onColumnSortChange: (changedColumn, direction) =>
                this.handleOnColumnSortChange(changedColumn, direction),
            }}
          />
        </MuiThemeProvider>
      </>
    );
  }
}

export type Props = IStateProps & IDispatchProps;

export interface IStateProps {
  apps: IStateApps;
  servers: IStateServers;
  viewType?: 'stock' | 'sold';
}

export interface IDispatchProps {
  setSerialsQuery: (query: IQuery) => void;
}

interface State {
  initialized: boolean;
  columns: MUIDataTableColumn[];
  serialsList: any;
  serialsTotalCounts: number;
}

const mapStateToProps = (state: IStoreState): Partial<IStateProps> => ({
  apps: state.apps,
  servers: state.servers,
});

const mapDispatchProps: IDispatchProps = {
  setSerialsQuery,
};

export const SakeHistoryForRestaurant = compose(connect(mapStateToProps, mapDispatchProps))(
  withConfirm(SakeHistoryForRestaurantClass),
);
